/* holster-finder-pdp.js — Phase 5 */
/* Reads ?hand=, ?gun=, ?light=, ?brand=, ?model= set by the holster finder
   and pre-selects matching Bold SCPO dropdowns on the product page. */

(function () {
  'use strict';

  var params = new URLSearchParams(window.location.search);
  var hand  = params.get('hand');
  var gun   = params.get('gun');
  var brand = params.get('brand');
  var model = params.get('model');
  var light = params.get('light');

  // No holster-finder params — nothing to do.
  if (!hand && !gun && !brand && !model && !light) return;

  // Our internal light IDs → Bold option text fragments to match against.
  // Listed most-specific first so longer strings match before shorter ones.
  var LIGHT_FRAGMENTS = {
    tlr1:    ['TLR-1 HL', 'TLR-1'],
    tlr7:    ['TLR-7 A', 'TLR-7A', 'TLR-7'],
    tlr7sub: ['TLR-7 Sub'],
    x300:    ['X300U', 'X300'],
    plpro:   ['PL-Pro', 'Baldr Pro', 'Baldr'],
    tcm:     ['TCM-550XL', 'TCM-550', 'TCM'],
  };

  function norm(s) {
    return (s || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  // Scope searches to Bold's known container elements when they exist, so we
  // don't accidentally target Shopify variant selects or other page selects.
  function getBoldRoot() {
    return (
      document.querySelector('#bold-product-options') ||
      document.querySelector('.bold_options_container') ||
      document.querySelector('.bold_option_container_outer') ||
      document.querySelector('[id^="bold_option"]') ||
      document.body
    );
  }

  // Return the first <select> inside the Bold container whose option text
  // contains any of the given fragments (case-insensitive, normalised).
  function findSelectByFragments(fragments) {
    var root = getBoldRoot();
    var selects = root.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      var sel = selects[i];
      for (var j = 0; j < sel.options.length; j++) {
        var optText = norm(sel.options[j].text);
        for (var k = 0; k < fragments.length; k++) {
          if (optText.includes(norm(fragments[k]))) return sel;
        }
      }
    }
    return null;
  }

  // Set the option in `sel` whose text best matches one of the fragments
  // (tries fragments in order, so more-specific strings win).
  function chooseOption(sel, fragments) {
    if (!sel) return false;
    for (var k = 0; k < fragments.length; k++) {
      var frag = norm(fragments[k]);
      for (var j = 0; j < sel.options.length; j++) {
        if (norm(sel.options[j].text).includes(frag)) {
          if (sel.value === sel.options[j].value) return true; // already selected
          sel.value = sel.options[j].value;
          // Fire both events — Bold listens to 'change'; some themes also listen to 'input'
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          sel.dispatchEvent(new Event('input',  { bubbles: true }));
          console.log('[holster-finder-pdp] pre-filled', (sel.name || sel.id || 'select'), '→', sel.options[j].text);
          return true;
        }
      }
    }
    return false;
  }

  // Build the ordered list of steps. Hand goes first because Bold conditionals
  // for gun/light options may depend on the hand selection being set already.
  function buildQueue() {
    var steps = [];
    if (hand) {
      var handFrags = hand === 'Right'
        ? ['Right Hand', 'Right-Hand', 'RH', 'Right']
        : ['Left Hand',  'Left-Hand',  'LH', 'Left'];
      steps.push({ label: 'hand', frags: handFrags });
    }
    if (gun)   steps.push({ label: 'gun',   frags: [gun] });
    if (brand) steps.push({ label: 'brand', frags: [brand] });
    if (model) steps.push({ label: 'model', frags: [model] });
    if (light && LIGHT_FRAGMENTS[light]) {
      steps.push({ label: 'light', frags: LIGHT_FRAGMENTS[light] });
    }
    return steps;
  }

  // Run steps sequentially with 400 ms between each so Bold has time to re-render
  // conditional options (e.g. gun list updates after hand is set).
  function runQueue(steps, idx) {
    if (idx >= steps.length) return;
    var step = steps[idx];
    var sel  = findSelectByFragments(step.frags);
    if (sel) {
      chooseOption(sel, step.frags);
    } else {
      console.log('[holster-finder-pdp] no Bold select found for param "' + step.label + '" — option may not exist on this product');
    }
    setTimeout(function () { runQueue(steps, idx + 1); }, 400);
  }

  // ----------------------------------------------------------------
  // Trigger logic: wait until Bold has rendered its selects, then run.
  // Bold renders async and may fire custom events or just inject DOM nodes.
  // We cover all three patterns: events, MutationObserver, and polling.
  // ----------------------------------------------------------------

  var queue   = buildQueue();
  var started = false;

  function tryStart() {
    if (started || !queue.length) return;
    var root = getBoldRoot();
    // Bold is ready when it has injected selects into its container, or when its
    // global is available. Products without Bold options will never satisfy this.
    var boldReady =
      (root !== document.body && root.querySelectorAll('select').length > 0) ||
      (typeof window.BOLD !== 'undefined' && window.BOLD.productOptions);
    if (!boldReady) return;
    started = true;
    // Small additional delay so Bold can finish any post-render setup
    setTimeout(function () { runQueue(queue, 0); }, 200);
  }

  // 1. Bold custom events
  ['BFS_LOADED', 'BOLD_COMMON_LOADED', 'bold:options:rendered', 'bold:product:loaded'].forEach(function (evt) {
    document.addEventListener(evt, tryStart);
  });

  // 2. MutationObserver — catches Bold injecting its container into the DOM
  if (typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(tryStart);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    // Stop watching after 15 s — Bold will have loaded by then or the product
    // simply doesn't use it.
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  // 3. Polling fallback at key post-load intervals
  [800, 1500, 2500, 4000].forEach(function (ms) {
    setTimeout(tryStart, ms);
  });
})();
